module.exports = require("object-assign");